import React, { memo } from 'react';
import { Avatar, Button, Dropdown, Tooltip } from 'antd';
import { ApartmentOutlined, ClusterOutlined, GlobalOutlined, IdcardOutlined, EditOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Handle, Position } from '@xyflow/react';

function MemberNode({ id, data }) {
    const initials = data.name.split(' ').map(part => part[0]).slice(0, 2).join('');
    const entityIcons = { organization: <GlobalOutlined />, division: <ApartmentOutlined />, department: <ClusterOutlined />, position: <IdcardOutlined /> };

    return (
        <article className={`organization-chart-member${data.entityType ? ' organization-chart-member--entity' : ''}`} style={{ '--member-accent': data.color }} aria-label={`${data.name}, ${data.role}`}>
            {data.actions ? (
                <Dropdown menu={{ items: data.actions }} trigger={['click']} disabled={data.actionsDisabled}>
                    <Button className="organization-chart-member__edit nodrag nopan" size="small" shape="circle"
                        aria-label={`Actions for ${data.name}`} disabled={data.actionsDisabled}>⋯</Button>
                </Dropdown>
            ) : data.onEdit && (
                <Tooltip title={data.entityType ? 'Edit unit' : 'Edit member'}>
                    <Button className="organization-chart-member__edit nodrag nopan" size="small" shape="circle"
                        icon={<EditOutlined />} aria-label={`Edit ${data.name}`} onClick={() => data.onEdit(id)} />
                </Tooltip>
            )}
            <Handle id="top" type="target" position={Position.Top} isConnectable={false} />
            <Handle id="left" type="target" position={Position.Left} isConnectable={false} />
            <div className="organization-chart-member__body">
                <Avatar size={34} src={data.avatar} alt={data.name} icon={entityIcons[data.entityType]}>{!data.entityType && initials}</Avatar>
                <div className="organization-chart-member__info">
                    <div className="organization-chart-member__name" title={data.name}>{data.name}</div>
                    <div className="organization-chart-member__role" title={data.role}>{data.role}</div>
                    {data.entityType && <div className="organization-chart-member__meta" title={data.code}>
                        {data.code || 'No code'}{data.entityType === 'position' && ` · Resources: ${data.record.pos_resource_total ?? '—'}`}
                        {data.record.is_active === false && ' · Inactive'}
                    </div>}
                </div>
            </div>
            <div className="organization-chart-member__accent" />
            <Handle id="bottom" type="source" position={Position.Bottom} isConnectable={false} />
            {data.childCount > 0 && (
                <Tooltip title={data.collapsed ? 'Expand branch' : 'Collapse branch'}>
                    <Button className="organization-chart-member__toggle nodrag nopan" size="small" shape="circle"
                        icon={data.collapsed ? <PlusOutlined /> : <MinusOutlined />}
                        aria-label={`${data.collapsed ? 'Expand' : 'Collapse'} ${data.name}`}
                        aria-expanded={!data.collapsed} onClick={() => data.onToggle(id)} />
                </Tooltip>
            )}
        </article>
    );
}

export default memo(MemberNode);
